module.exports = __webpack_public_path__ + "img/b-end.ff6a524.png";